// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/ratemodificationconsts.proto (package aurora.core.consts.contractratemodification, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/ratemodificationconsts.proto.
 */
export const file_consts_ratemodificationconsts: GenFile = /*@__PURE__*/
  fileDesc("CiNjb25zdHMvcmF0ZW1vZGlmaWNhdGlvbmNvbnN0cy5wcm90bxIrYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0cmF0ZW1vZGlmaWNhdGlvbiqSAQoeQ29udHJhY3RSYXRlTW9kaWZpY2F0aW9uU3RhdHVzEg8KC1VOU1BFQ0lGSUVEEAASDAoIUFJPUE9TRUQQARIMCghBQ0NFUFRFRBACEg0KCUZJTkFMSVpFRBADEgwKCFJFSkVDVEVEEAQSDAoIQ0FOQ0VMRUQQBRILCgdEUk9QUEVEEAYSCwoHRVhQSVJFRBAHQilaJ2dpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL2NvbnN0c2IGcHJvdG8z");

/**
 * Different stages of a rate renegotiation
 *
 * @generated from enum aurora.core.consts.contractratemodification.ContractRateModificationStatus
 */
export enum ContractRateModificationStatus {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROPOSED = 1;
   */
  PROPOSED = 1,

  /**
   * @generated from enum value: ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: FINALIZED = 3;
   */
  FINALIZED = 3,

  /**
   * @generated from enum value: REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: DROPPED = 6;
   */
  DROPPED = 6,

  /**
   * @generated from enum value: EXPIRED = 7;
   */
  EXPIRED = 7,
}

/**
 * Describes the enum aurora.core.consts.contractratemodification.ContractRateModificationStatus.
 */
export const ContractRateModificationStatusSchema: GenEnum<ContractRateModificationStatus> = /*@__PURE__*/
  enumDesc(file_consts_ratemodificationconsts, 0);

